import React, { useEffect, useState } from 'react';

import './Stamp.single.billed.scss';
import { SearchOrderBinded } from '../../models/Orders_v2';
import { ProfileQL } from '../../models/Profile';
import { FiscalpopCFDI } from '../../models/Factura';
import { numberToCurrencyString } from '../../services/formatting';
import Button from '../Forms/Button';
import Loading from '../Animations/loadScreen';

import Modal from 'react-modal';
import { useMutation } from '@apollo/client';
import { graphqlSchema } from '../../services/graphql.schema';
import { Redirect } from 'react-router-dom';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import { fiscalpopApi, downloadUrls } from '../../services/fiscalpopApi';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '80vh',
        padding: '1em 2em',
        border: 'none',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)',
    }
};


function StampSingleBilled({ orderBilled, currentUser, handleManualOverride, reFetchOrder }: { orderBilled: SearchOrderBinded, currentUser: ProfileQL, handleManualOverride: () => void, reFetchOrder: () => void }) {
    console.log('[StampSingleBilled] orderBilled: ', orderBilled);
    const [cfdi, setCfdi] = useState<FiscalpopCFDI>(null);

    const [forceReturnModalOpen, setForceReturnModalOpen] = useState(false);
    const [cancelModalOpen, setCancelModalOpen] = useState(false);
    const [wasCancelled, setWasCancelled] = useState(false);
    const [isRefunding, setIsRefunding] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);

    const xmlLinkRef = React.createRef<HTMLAnchorElement>();
    const pdfLinkRef = React.createRef<HTMLAnchorElement>();

    const [setCancel] = useMutation(graphqlSchema.FISCALPOP.CFDI.setBillToCancel, {
        onCompleted: ({ setBillToCancel }: { setBillToCancel: { folios: { estatus: number; uuid: string }[] } }) => {
            console.log('Canceled CFDI: ', setBillToCancel);
            // Redirect user?
            setWasCancelled(true);
            setIsCancelling(false);
            sharedToasterSubject.next({ type: 'confirm', message: 'Se canceló la factura' });
        },
        onError: (e) => {
            setIsCancelling(false);
            console.error('Error canceling cfdi: ', e);
            sharedToasterSubject.next({ type: 'error', message: 'Error al cancelar la factura' });
        }
    })
    const [setRefunded] = useMutation(graphqlSchema.FISCALPOP.CFDI.setOrderToCancel, {
        onCompleted: ({ setOrderToCancel }: { setOrderToCancel: { canceled: boolean, refundUUID: string } }) => {
            console.log('Refunded Order: ', setOrderToCancel);
            // Redirect user?
            reFetchOrder();
            setIsRefunding(false);
            if (setOrderToCancel.canceled && setOrderToCancel.refundUUID) {
                sharedToasterSubject.next({ type: 'confirm', message: 'Se marcó cancelado y se emitió la nota de crédito' });
                return;
            }
            if (setOrderToCancel.canceled && !setOrderToCancel.refundUUID) {
                sharedToasterSubject.next({ type: 'warning', message: 'Se marcó cancelado pero no se pudo emitir la nota de crédito' });
                return;
            }
            sharedToasterSubject.next({ type: 'confirm', message: 'Se marcó como Cancelado' });
        },
        onError: (e) => {
            reFetchOrder();
            setIsRefunding(false);
            console.error('Error forcing Cancel on order: ', e);
            sharedToasterSubject.next({ type: 'error', message: 'Error al marcar pedido como Cancelado' });
        }
    })

    useEffect(() => {
        if (!!orderBilled && !!currentUser && !!currentUser.amazonProfile) {
            fiscalpopApi.cfdi.findByUuid(orderBilled.binder.billUUID)
                .then((cfdiResponse: FiscalpopCFDI[]) => {
                    console.log('CFDI: ', cfdiResponse);
                    setCfdi(cfdiResponse[0]);
                })

        }
    }, [orderBilled, currentUser]);


    const openPdf = () => {
        pdfLinkRef.current.click();
    }
    const openXml = () => {
        xmlLinkRef.current.click();
    }

    const requestCancelCfdi = () => {
        setCancelModalOpen(true);
    }
    
    const requestRefundOrder = () => {
        setForceReturnModalOpen(true);
    }

    const cancelCFDI = () => {
        setCancelModalOpen(false);
        setIsCancelling(true);
        setCancel({
            variables: {
                uuid: orderBilled.binder.billUUID
            }
        })
    }

    const refundCFDI = () => {
        setForceReturnModalOpen(false);
        setIsRefunding(true);
        setRefunded({
            variables: {
                orderId: orderBilled.order.orderId
            }
        })
    }

    const renderForceReturnDialog = () => {
        return (
            <Modal
                isOpen={forceReturnModalOpen}
                onRequestClose={() => setForceReturnModalOpen(false)}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Marcar devolución"
            >
                <div className="ReturnWarning">
                    <h4>
                        Deseas marcar el pedido como devuelto?
                    </h4>
                    <p>
                        Si detectaste una devolución en Seller Central que no se refleja en FiscalPOP, márcalo como Cancelado para registrar el cambio.
                    </p>
                    <p className="warning">
                        <b>
                            Al actualizarse como <em>Cancelado</em> se creará la nota de crédito.
                        </b>
                    </p>
                    <p>

                    </p>
                    <div className="actions">
                        <Button primary={true} handleClick={() => setForceReturnModalOpen(false)}>
                            <span>Regresar</span>
                        </Button>
                        <Button accent={true} disabled={isRefunding} handleClick={refundCFDI}>
                            {
                                isRefunding ?
                                    <span>Espere...</span>
                                    :
                                    <span>Marcar Cancelado</span>
                            }
                        </Button>
                    </div>
                </div>
            </Modal>
        )
    }

    const renderCancelDialog = () => {
        return (
            <Modal
                isOpen={cancelModalOpen}
                onRequestClose={() => setCancelModalOpen(false)}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Cancelar Factura"
            >
                <div className="CancelWarning">
                    <h4>
                        Realmente quieres cancelar tu factura ?
                    </h4>
                    <p className="warning">{orderBilled.binder.billUUID}</p>
                    <p>
                        Este UUID quedará cancelado pero podrás volver a facturar los pedidos en otro UUID.
                    </p>
                    <div className="actions">
                        <Button primary={true} handleClick={() => setCancelModalOpen(false)}>
                            <span>Regresar</span>
                        </Button>
                        <Button accent={true} disabled={isCancelling} handleClick={cancelCFDI}>
                            {
                                isCancelling ?
                                    <span>Cancelando</span>
                                    :
                                    <span>Cancelar factura</span>
                            }
                        </Button>
                    </div>
                </div>
            </Modal>
        )
    }

    const renderCfdi = () => {
        return (
            <div className="cfdiInform">
                <div className='_informTitleActions'>
                    <div className='_title'>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" className="_inform">
                            <path d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z" />
                        </svg>
                        <p className="_inform">
                            Esta órden ya fué facturada
                        </p>
                    </div>
                    {
                        orderBilled.order.orderStatus === 'CANCELLED' ?
                            null :
                            <div className='_forceCancel noselect' onClick={requestRefundOrder}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" className="_warning">
                                    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
                                </svg>
                                <p className="_inform noselect">
                                    Marcar como devolución
                                </p>
                            </div>
                    }
                </div>
                <div className="card _cfdiBilled">
                    <div className="_label _whole">
                        <p className="_key">UUID:</p>
                        <p className="_value accent">{cfdi.uuid}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Folio</p>
                        <p className="_value">{cfdi.json['@']['Folio']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Serie</p>
                        <p className="_value">{cfdi.json['@']['Serie']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Forma Pago</p>
                        <p className="_value">{cfdi.json['@']['FormaPago']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Lugar Expedición</p>
                        <p className="_value">{cfdi.json['@']['LugarExpedicion']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Fecha</p>
                        <p className="_value">{cfdi.json['@']['Fecha']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Subtotal</p>
                        <p className="_value">$ {numberToCurrencyString(parseFloat(cfdi.json["@"].SubTotal))}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Descuento</p>
                        <p className="_value">$ {numberToCurrencyString(parseFloat(cfdi.json["@"]['Descuento'] || '0'))}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Total</p>
                        <p className="_value">$ {numberToCurrencyString(parseFloat(cfdi.json["@"].Total))}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Impuestos Trasladados</p>
                        <p className="_value">$ {numberToCurrencyString(parseFloat(cfdi.json["cfdi:Impuestos"]["@"].TotalImpuestosTrasladados))}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Estado</p>
                        <p className={`_value ${cfdi.status ? '' : 'accent'}`}>{cfdi.status ? 'Emitida' : 'Cancelada'}</p>
                    </div>
                    <div className="_label _whole">
                        <p className="_key">Sello</p>
                        <p className="_value">{cfdi.json["@"].Sello}</p>
                    </div>
                </div>
                <div className="cfdiDownloads">
                    <Button tertiary={true} handleClick={requestCancelCfdi}>
                        <span>Cancelar CFDI</span>
                    </Button>
                    {
                        orderBilled.binder.billIsGlobal ?
                            <Button tertiary={true} secondary={true} handleClick={handleManualOverride} disabled={orderBilled.order.orderStatus === 'CANCELLED'}>
                                <span>Emitir a cliente</span>
                            </Button>
                            : <div></div>
                    }
                    <div className="__links">
                        <a ref={xmlLinkRef} rel="noopener noreferrer" href={downloadUrls.cfdiXml(cfdi.uuid)} download={true}>Descargar XML</a>
                        <a ref={pdfLinkRef} rel="noopener noreferrer" href={downloadUrls.cfdiPdf(cfdi.uuid)} download={true}>Descargar PDF</a>
                    </div>
                    <Button secondary={true} handleClick={openXml}>
                        <span>Descargar XML</span>
                    </Button>
                    <Button primary={true} handleClick={openPdf}>
                        <span>Descargar PDF</span>
                    </Button>
                </div>
                {renderCancelDialog()}
                {renderForceReturnDialog()}
            </div>
        )
    }

    return (
        <div id="StampSingleBilled">
            {
                (cfdi && currentUser.amazonProfile) ?
                    renderCfdi()
                    : <Loading display={true} />
            }
            {
                wasCancelled ?
                    <Redirect to='/ordenes' />
                    : ''
            }
        </div>
    )
}

export default StampSingleBilled;